module.exports = __webpack_public_path__ + "f71600f276e98469c9d3229a56c7f5ed.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-0.png
// module id = 2067
// module chunks = 0